import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "pagination-shell-inner"
};
const _hoisted_2 = {
  key: 0,
  class: "pagination-info-group"
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  class: "font-medium text-slate-700"
};
const _hoisted_5 = {
  key: 1,
  class: "pagination-size-group"
};
const _hoisted_6 = {
  key: 0
};
const _hoisted_7 = ["value"];
const _hoisted_8 = ["value"];
const _hoisted_9 = {
  key: 1
};
const _hoisted_10 = {
  key: 1,
  class: "pagination-pager-group"
};
const _hoisted_11 = ["disabled"];
const _hoisted_12 = ["aria-current", "onClick"];
const _hoisted_13 = ["disabled"];
import { computed } from 'vue';
export default {
  __name: 'AppPagination',
  props: {
    pagination: {
      type: Object,
      default: () => ({})
    },
    current: {
      type: Number,
      default: undefined
    },
    size: {
      type: Number,
      default: undefined
    },
    total: {
      type: Number,
      default: undefined
    },
    pages: {
      type: Number,
      default: undefined
    },
    hasPrevious: {
      type: Boolean,
      default: undefined
    },
    hasNext: {
      type: Boolean,
      default: undefined
    },
    pageSizes: {
      type: Array,
      default: () => [10, 20, 50]
    },
    pageWindow: {
      type: Number,
      default: 2
    },
    showTotal: {
      type: Boolean,
      default: true
    },
    showPageSize: {
      type: Boolean,
      default: true
    },
    showPager: {
      type: Boolean,
      default: true
    },
    totalLabel: {
      type: String,
      default: '共 '
    },
    totalSuffix: {
      type: String,
      default: ' 条'
    },
    pageSizeLabel: {
      type: String,
      default: '每页'
    },
    pageSizeSuffix: {
      type: String,
      default: '条'
    },
    prevText: {
      type: String,
      default: '上一页'
    },
    nextText: {
      type: String,
      default: '下一页'
    }
  },
  emits: ['page-change', 'size-change', 'update:current', 'update:page', 'update:size'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const currentPage = computed(() => {
      const raw = props.current ?? props.pagination?.current ?? props.pagination?.page ?? 1;
      return Math.max(1, Number(raw) || 1);
    });
    const pageSize = computed(() => {
      const fallback = Array.isArray(props.pageSizes) && props.pageSizes.length > 0 ? Number(props.pageSizes[0]) : 10;
      const raw = props.size ?? props.pagination?.size ?? props.pagination?.pageSize ?? fallback;
      return Math.max(1, Number(raw) || fallback);
    });
    const totalItems = computed(() => {
      const raw = props.total ?? props.pagination?.total ?? 0;
      return Math.max(0, Number(raw) || 0);
    });
    const totalPages = computed(() => {
      // total 与信息栏“共 N 条 / 每页 M 条”同源，优先由它推导，避免后端 pages 字段不准时页码缺失
      if (totalItems.value > 0) {
        return Math.max(1, Math.ceil(totalItems.value / pageSize.value));
      }
      const explicitPages = props.pages ?? props.pagination?.pages ?? props.pagination?.totalPages;
      if (explicitPages !== undefined && explicitPages !== null && explicitPages !== '') {
        return Math.max(1, Number(explicitPages) || 1);
      }
      return 1;
    });
    const canGoPrevious = computed(() => {
      if (props.hasPrevious !== undefined) return props.hasPrevious;
      if (props.pagination?.hasPrevious !== undefined) return props.pagination.hasPrevious;
      return currentPage.value > 1;
    });
    const canGoNext = computed(() => {
      if (props.hasNext !== undefined) return props.hasNext;
      if (props.pagination?.hasNext !== undefined) return props.pagination.hasNext;
      return currentPage.value < totalPages.value;
    });
    const visiblePages = computed(() => {
      const total = totalPages.value;
      const current = Math.min(currentPage.value, total);
      const windowRadius = Math.max(1, Number(props.pageWindow) || 1);
      const span = windowRadius * 2 + 1;
      let start = Math.max(1, current - windowRadius);
      let end = Math.min(total, current + windowRadius);

      // 贴近首尾时补齐窗口，保证页码数量稳定
      if (end - start + 1 < span) {
        if (start === 1) {
          end = Math.min(total, start + span - 1);
        } else if (end === total) {
          start = Math.max(1, end - span + 1);
        }
      }
      const pages = [];
      for (let page = start; page <= end; page += 1) {
        pages.push(page);
      }
      return pages;
    });
    const normalizedPageSizes = computed(() => props.pageSizes.map(size => Number(size)).filter(size => Number.isFinite(size) && size > 0));
    const showInfo = computed(() => props.showTotal || props.showPageSize);
    const shellClass = computed(() => ({
      'has-info-only': showInfo.value && !props.showPager,
      'has-pager-only': props.showPager && !showInfo.value
    }));
    const handlePageChange = page => {
      if (page < 1 || page > totalPages.value || page === currentPage.value) return;
      emit('update:current', page);
      emit('update:page', page);
      emit('page-change', page);
    };
    const handleSizeChange = event => {
      const size = Number(event?.target?.value || pageSize.value);
      if (!size || size === pageSize.value) return;
      emit('update:size', size);
      emit('size-change', size);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["pagination-shell", shellClass.value])
      }, [_createElementVNode("div", _hoisted_1, [showInfo.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, [__props.showTotal ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createTextVNode(_toDisplayString(__props.totalLabel) + " ", 1), _createElementVNode("span", _hoisted_4, _toDisplayString(totalItems.value), 1), _createTextVNode(" " + _toDisplayString(__props.totalSuffix), 1)])) : _createCommentVNode("", true), __props.showPageSize ? (_openBlock(), _createElementBlock("label", _hoisted_5, [__props.pageSizeLabel ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(__props.pageSizeLabel), 1)) : _createCommentVNode("", true), _createElementVNode("select", {
        value: pageSize.value,
        class: "form-page-size",
        onChange: handleSizeChange
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(normalizedPageSizes.value, option => {
        return _openBlock(), _createElementBlock("option", {
          key: option,
          value: option
        }, _toDisplayString(option), 9, _hoisted_8);
      }), 128))], 40, _hoisted_7), __props.pageSizeSuffix ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(__props.pageSizeSuffix), 1)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), __props.showPager ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("button", {
        class: "pagination-nav-button",
        disabled: !canGoPrevious.value,
        onClick: _cache[0] || (_cache[0] = $event => handlePageChange(currentPage.value - 1))
      }, _toDisplayString(__props.prevText), 9, _hoisted_11), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visiblePages.value, page => {
        return _openBlock(), _createElementBlock("button", {
          key: page,
          class: _normalizeClass(["pagination-page-button", {
            'is-active': page === currentPage.value
          }]),
          "aria-current": page === currentPage.value ? 'page' : undefined,
          onClick: $event => handlePageChange(page)
        }, _toDisplayString(page), 11, _hoisted_12);
      }), 128)), _createElementVNode("button", {
        class: "pagination-nav-button",
        disabled: !canGoNext.value,
        onClick: _cache[1] || (_cache[1] = $event => handlePageChange(currentPage.value + 1))
      }, _toDisplayString(__props.nextText), 9, _hoisted_13)])) : _createCommentVNode("", true)])], 2);
    };
  }
};